import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '../../providers/auth/auth.service';
import { HelpersProvider } from '../../providers/helpers/helpers';
import { I18nProvider } from '../../providers/i18n/i18n';
import { environment } from '../../environments/environment';
import {
  applyLayoutTheme,
  canUseLayoutTheme,
  isModernLayoutTheme,
  LAYOUT_THEMES,
  LAYOUT_THEME_STORAGE_KEY,
  LayoutThemeValue,
  normalizeLayoutTheme,
} from '../../providers/layout-theme/layout-theme';

@Component({
  selector: 'app-nav-teacher',
  templateUrl: './nav-teacher.component.html',
  // styleUrls: ['./material-sidenav.component.scss']
})
export class NavTeacherComponent implements OnInit {
  readonly layoutThemes = LAYOUT_THEMES;
  readonly layoutThemeStorageKey = LAYOUT_THEME_STORAGE_KEY;

  STRINGS: any;
  PAGE: any;
  @ViewChild('snav', {static: false}) sidenav: MatSidenav;
  public user: any;
  minimize = false;
  userLogo = 'assets/imgs/logo-topo-stcoach.png';
  firstName = 'Fulano';
  userPayment = '';
  teacherShowAlertPayment = false;
  ismobile: boolean = false;
  selectedLayoutTheme: LayoutThemeValue = 'modern-dark';
  canShowLayoutThemeSelector = false;
  readonly showTeacherReferrals = ['local', 'homolog'].includes(environment.dev);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    public toastr: ToastrService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    public helpers: HelpersProvider,
    private device: DeviceDetectorService,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('MenuUI');
    this.ismobile = this.device.isMobile();
  }

  ngOnInit() {
    this.user = this.auth.retrieveLocalUser();
    this.firstName = this.auth.getFirstName();
    this.canShowLayoutThemeSelector = this.canUseLayoutThemeSelector();
    this.selectedLayoutTheme = this.canShowLayoutThemeSelector
      ? this.normalizeLayoutTheme(localStorage.getItem(this.layoutThemeStorageKey))
      : 'modern-dark';
    if (this.canShowLayoutThemeSelector) {
      localStorage.setItem(this.layoutThemeStorageKey, this.selectedLayoutTheme);
    }
    this.applyLayoutTheme(this.selectedLayoutTheme);
    this.getLogo();
    this.getPaymentStatus();
  }

  toogleMini() {
    // console.log('minimenu');
    this.minimize = !this.minimize;
  }

  closeSnav() {
    this.sidenav.close();
    this.minimize = false;
  }

  getLogo() {
    if (this.userLogo === null || this.userLogo.indexOf('assets/imgs/logo-topo-stcoach.png') !== -1) this.userLogo = 'assets/imgs/logo-topo-stcoach.png';
    if (this.user.subs === undefined) return false;
    if (this.user.subs.supertreinos_plan_id && (
        this.user.subs.supertreinos_plan_id === '3' ||
        this.user.subs.supertreinos_plan_id === '4' ||
        this.user.subs.supertreinos_plan_id === 3 ||
        this.user.subs.supertreinos_plan_id === 4 ))
    {
      this.userLogo = this.user.logo;
      if (this.userLogo === null || this.userLogo.indexOf('assets/imgs/logo-topo-stcoach.png') !== -1) this.userLogo = 'assets/imgs/logo-topo-stcoach.png';
    }

    return false;
  }

  getPaymentStatus() {
    if (this.user.subs.supertreinos_plan_id === "0") return false;
    // console.log(this.user);

    if (this.user.subs.pagarme !== null) {
      this.userPayment = this.user.subs.pagarme.status;
      if (this.userPayment === 'pending_payment') {
        this.helpers.storeLocally('teacherShowAlertPayment', true, 0);
      }
    }

    this.teacherShowAlertPayment = this.helpers.getLocallyStored('teacherShowAlertPayment');
  }

  manageSubs() {
    if (!this.canManagePagarme()) return;
    window.open(this.user.subs.pagarme.manage_url, '_blank');
  }

  canManagePagarme() {
    return !!(this.user?.subs?.pagarme?.manage_url);
  }

  alertClose() {
    this.helpers.storeLocally('teacherShowAlertPayment', false, 0);
    this.teacherShowAlertPayment = false;
  }

  changeLayoutTheme(theme: string) {
    if (!this.canShowLayoutThemeSelector) return;

    this.selectedLayoutTheme = normalizeLayoutTheme(theme);
    localStorage.setItem(this.layoutThemeStorageKey, this.selectedLayoutTheme);
    this.applyLayoutTheme(this.selectedLayoutTheme);
  }

  getSelectedLayoutThemeLabel() {
    const selectedTheme = this.layoutThemes.find(layoutTheme => layoutTheme.value === this.selectedLayoutTheme);

    return selectedTheme ? selectedTheme.label : 'Classic dark';
  }

  normalizeLayoutTheme(theme: string) {
    return normalizeLayoutTheme(theme);
  }

  canUseLayoutThemeSelector() {
    return canUseLayoutTheme(this.user, environment.dev);
  }

  applyLayoutTheme(theme: string) {
    applyLayoutTheme(normalizeLayoutTheme(theme));
  }

  getDashboardRoute() {
    return '/professor/dashboard';
  }

  isModernLayoutTheme() {
    return isModernLayoutTheme(this.selectedLayoutTheme);
  }

  changeLanguage(lang: string = 'br') {
    // console.log(lang);
    this.helpers.storeLocally('language', lang, 0);
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('MenuUI');
    location.reload();

  }

  goToApps() {
    this.router.navigate(['professor/perfil'], { skipLocationChange: true, queryParams: { tab: 2 } });
  }

}
